import { ButtonProps } from '@usacsmideo/types';

export const ButtonRed = (props: ButtonProps) => (
  <button
    id={props.id}
    className="m-2 rounded-md bg-red-700 px-4 py-2 text-xl text-white hover:bg-red-900 disabled:border-slate-200 disabled:bg-slate-50 disabled:text-slate-500 disabled:shadow-none sm:px-8 sm:py-3"
    type={props.type || 'button'}
    onClick={props.onClick}
    disabled={props.disabled}
  >
    {props.textContent}
  </button>
);
